import React from 'react';
import {
	StyledCircle1,
	StyledCircle2,
	StyledCircularLoaderWrapper
} from './styled';

interface CircularLoaderProps {
    advanced?: boolean;
}

const CircularLoader: React.FC<CircularLoaderProps> = ({
	advanced = false,
}) => {
	return (
		<>
			{
				advanced ? (
					<StyledCircularLoaderWrapper>
						<StyledCircle1 />
						<StyledCircle2 />
					</StyledCircularLoaderWrapper>
				) : (
					<StyledCircularLoaderWrapper>
						<StyledCircle1 />
					</StyledCircularLoaderWrapper>
				)
			}
		</>
	);
};

export default CircularLoader;